import { useQuery } from "@tanstack/react-query";
import { getBrevoLists } from "../../api/bBrevoApi";

export const useGetBrevoLists = (organisationId) => {
  return useQuery({
    queryKey: ["brevo-lists", organisationId],
    queryFn: () => getBrevoLists(organisationId),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
